import React, { memo, useState, useRef, lazy, Suspense } from "react";
import { array } from "prop-types";
import { useDispatch } from "react-redux";
import { baseURLAdmin, commonHeaderAdmin } from "api/constants";
import { showNotification } from "redux/notification/actions";
import { MoreVert } from "@material-ui/icons";
import { IconButton } from "@material-ui/core";
import { Popper } from "@material-ui/core";
import { Fade } from "@material-ui/core";
import styles from "./style.module.scss";

const BaseModal = lazy(() => import("components/Modal"));

// eslint-disable-next-line react/prop-types
const Action = ({ attributes, refetch, sourceId }) => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [isOpenConfirm, setIsOpenConfirm] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const handleClickMoreVert = (e) => {
    setAnchorEl(e.currentTarget);
    setOpen((previousOpen) => !previousOpen);
  };

  const idAttributeRef = useRef(null);

  const handleRemoveAttribute = async () => {
    const response = await fetch(
      `${baseURLAdmin}/data-registry/${idAttributeRef.current}/unassign-source`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ sourceIds: [sourceId] }),
        ...commonHeaderAdmin,
      },
    );

    const json = await response.json();
    if (!response.ok) {
      dispatch(
        showNotification({
          type: "error",
          msg: json?.message ?? json?.messages,
          msgId: json?.message ?? json?.messages,
        }),
      );
    } else {
      dispatch(
        showNotification({
          type: "success",
          msg: "Delete attribute succesfully",
          msgId: "Delete attribute succesfully",
        }),
      );
      idAttributeRef.current = null;
      setAnchorEl(null);
      setOpen(false);
      refetch();
    }
  };

  const handleOpenConfirm = (id) => {
    setIsOpenConfirm(true);
    idAttributeRef.current = id;
  };

  const handleClosePopup = () => {
    setAnchorEl(null);
    setOpen(false);
    idAttributeRef.current = null;
  };

  const canBeOpen = open && Boolean(anchorEl);
  return (
    <>
      <IconButton onClick={handleClickMoreVert}>
        <MoreVert />
      </IconButton>

      <Popper
        id={canBeOpen ? "transition-popper" : undefined}
        open={open}
        anchorEl={anchorEl}
        transition
        placement="bottom-start"
      >
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={350}>
            <div className={styles.actionBg}>
              <div className={styles.header}>
                <span className={styles.headLine}>Remove Attributes</span>
                <span style={{ cursor: "pointer" }} onClick={handleClosePopup}>
                  x
                </span>
              </div>
              <div className={styles.list}>
                {attributes.map((attribute) => (
                  <div key={attribute.dataRegistryId} className={styles.row}>
                    <span>{`${attribute.dataRegistryName} version ${attribute.majorVersion}.${attribute.minorVersion}`}</span>
                    <span
                      style={{ color: "red", cursor: "pointer" }}
                      onClick={() =>
                        handleOpenConfirm(attribute.dataRegistryId)
                      }
                    >
                      Remove
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </Fade>
        )}
      </Popper>

      {open && (
        <Suspense fallback={<></>}>
          <BaseModal
            isOpen={isOpenConfirm}
            setIsOpen={setIsOpenConfirm}
            title="Confirmation"
            content="Do you want delete this attribute"
            handleSubmit={handleRemoveAttribute}
          />
        </Suspense>
      )}
    </>
  );
};

export default memo(Action);

Action.propTypes = {
  attributes: array,
};
